import useAxios from "./useAxios"
import repositories, { IEndpointsContext } from '../../api'

const useRepository = <T>(reducer: (_: IEndpointsContext) => T) => reducer(repositories(useAxios()))

export default useRepository
